module.exports = __webpack_public_path__ + "img/xiaojia.b48fb6ea.png";